import React from 'react';
import { Event } from '../../../domain/entities/Event';
import { APP_CONFIG } from '../../../shared/constants/AppConfig';
import './EventCard.css';
import { GoogleCalendarButton } from '../GoogleCalendarButton';

interface EventCardProps {
  event: Event;
}

export const EventCard: React.FC<EventCardProps> = ({ event }) => {
  // Google Calendar URL igual VisitaGuiadaCard
  const eventDate = event.date.value;
  const eventTime = event.time.value;
  const [hours, minutes] = eventTime.split(':').map(Number);
  const startDate = new Date(eventDate);
  startDate.setHours(hours, minutes, 0, 0);

  let endDate: Date;
  if (event.endTime && event.endTime.value) {
    const [endHours, endMinutes] = event.endTime.value.split(':').map(Number);
    endDate = new Date(eventDate);
    endDate.setHours(endHours, endMinutes, 0, 0);
    // Se endDate for antes de startDate, assume +1 dia (evento que cruza meia-noite)
    if (endDate <= startDate) {
      endDate.setDate(endDate.getDate() + 1);
    }
  } else {
    endDate = new Date(startDate.getTime() + 60 * 60 * 1000);
  }

  const formatDate = (date: Date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };
  const dates = `${formatDate(startDate)}/${formatDate(endDate)}`;
  const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(APP_CONFIG.ORGANIZATION_NAME + ' - ' + event.title.value)}&dates=${dates}&details=${encodeURIComponent(event.subtitle.value + '\n\nInstrutor: ' + event.instructor.value + '\n\n' + APP_CONFIG.ORGANIZATION_NAME)}&location=${encodeURIComponent(APP_CONFIG.ADDRESS)}`;

  return (
    <div className="event-card">
      <div className="event-header">
        <div className="event-title-section">
          <h3 className="event-title">{event.title.value}</h3>
          <p className="event-subtitle">{event.subtitle.value}</p>
        </div>
      </div>
      
      <div className="event-details">
        <div className="event-detail">
          <i className="fas fa-calendar-alt detail-icon"></i>
          <span>{event.getFormattedDate()}</span>
        </div>
        <div className="event-detail">
          <i className="fas fa-clock detail-icon"></i>
          <span>{event.time.value}</span>
        </div>
      </div>
      
      <GoogleCalendarButton url={googleCalendarUrl} className="calendar-button" title="Adicionar ao Google Calendar" />
    </div>
  );
}; 